import {
  DndContext,
  DragOverlay,
  closestCorners,
} from '@dnd-kit/core'
import React from 'react'
import styled from 'styled-components/macro'
import { CATCH_BOARD_STAGES } from './catchBoardConstants'
import CatchBoardColumn from './CatchBoardColumn'
import { CatchBoardCardFace } from './CatchBoardCard'

/**
 * Horizontal kanban board with @dnd-kit drag between / within columns.
 */
const CatchBoardBoard = ({
  columns = {},
  columnTotalsByStage = {},
  sensors,
  activeDeal,
  onDragStart,
  onDragOver,
  onDragEnd,
  onDragCancel,
  onDealClick,
}) => (
  <BoardScroll data-testid='catch-board-board'>
    <DndContext
      sensors={sensors}
      collisionDetection={closestCorners}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
      onDragCancel={onDragCancel}
    >
      <BoardRow>
        {CATCH_BOARD_STAGES.map(stage => {
          const column = columns[stage] || { stage, deals: [], meta: null }
          const totals = columnTotalsByStage[stage]

          return (
            <CatchBoardColumn
              key={stage}
              stage={stage}
              meta={column.meta}
              deals={column.deals || []}
              dealCount={totals?.dealCount ?? column.deals?.length ?? 0}
              dealValueLabel={totals?.dealValueLabel || '—'}
              potentialDealValueLabel={totals?.potentialDealValueLabel}
              potentialDealValuePence={totals?.potentialDealValuePence || 0}
              onDealClick={onDealClick}
            />
          )
        })}
      </BoardRow>

      <DragOverlay dropAnimation={null}>
        {activeDeal ? (
          <OverlayCard>
            <CatchBoardCardFace deal={activeDeal} />
          </OverlayCard>
        ) : null}
      </DragOverlay>
    </DndContext>
  </BoardScroll>
)

const BoardScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  padding-bottom: 4px;
`

const BoardRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 12px;
  min-width: max-content;
`

const OverlayCard = styled.div`
  width: 240px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  border-radius: 6px;
`

export default CatchBoardBoard
